import { Subject } from "rxjs";
import * as i0 from "@angular/core";
var SidebarNavService = /** @class */ (function () {
    function SidebarNavService() {
        this.triggerEvent = new Subject();
        this.triggerEvent$ = this.triggerEvent.asObservable();
        this.formChangeDetection = false;
        this._metaData = undefined;
        this.menuItems = undefined;
        this._defaultSelectedId = undefined;
        this._groups = [];
        this._menuItemsByGroup = {};
    }
    SidebarNavService.prototype.dispatchEvent = function (actionName, data) {
        if (data === void 0) { data = {}; }
        data['actionName'] = actionName;
        this.triggerEvent.next(data);
    };
    SidebarNavService.prototype.setMetadata = function (data) {
        this._metaData = data;
        this.menuItems = data.items;
        if (data.hasOwnProperty('groups')) {
            this._groups = data.groups;
            this._menuItemsByGroup = data.items.reduce(function (r, a) {
                r[a.groupId] = r[a.groupId] || [];
                r[a.groupId].push(a);
                return r;
            }, {});
            console.log('group', this._menuItemsByGroup);
        }
    };
    Object.defineProperty(SidebarNavService.prototype, "groups", {
        get: function () {
            return this._groups;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidebarNavService.prototype, "menuItemsGroup", {
        get: function () {
            return this._menuItemsByGroup;
        },
        enumerable: true,
        configurable: true
    });
    SidebarNavService.prototype.setDefaultSelectedId = function (id) {
        this._defaultSelectedId = id;
    };
    SidebarNavService.prototype.getMetadata = function () {
        return this._metaData;
    };
    SidebarNavService.prototype.showProgressBar = function () {
        return this._metaData.showProgressBar;
    };
    SidebarNavService.prototype.getMenuItems = function () {
        return this.menuItems;
    };
    SidebarNavService.prototype.setActiveGroupItem = function (groupId, itemId) {
        var groupItems = this._menuItemsByGroup[groupId];
        if (groupItems) {
            this.setActiveItem(itemId, groupItems);
        }
    };
    SidebarNavService.prototype.setActiveItem = function (id, menuItems) {
        if (menuItems === void 0) { menuItems = undefined; }
        if (this._defaultSelectedId) {
            id = this._defaultSelectedId;
            this._defaultSelectedId = undefined;
        }
        var _item;
        var _menutItems = typeof menuItems != 'undefined' ? menuItems : this.menuItems;
        if (!id) {
            var lastIndex = this._findLastIndex('status', 'in_progress');
            if (lastIndex < 0) {
                lastIndex = this._findLastIndex('status', 'completed');
            }
            _item = _menutItems[lastIndex];
        }
        else {
            _item = _menutItems.find(function (item) { return item.id == id; });
        }
        if (_item) {
            this._resetSelected();
            _item.selected = true;
            var totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _item,
                totalProgress: totalProgress
            });
        }
    };
    SidebarNavService.prototype.goTo = function (currentId, nextAction) {
        var currentIndex = this.menuItems.findIndex(function (item) { return item.id == currentId; }), nextIndex, _currentItem, _nextItem;
        if (nextAction === 'next') {
            nextIndex = currentIndex + 1;
        }
        else if (nextAction === 'prev') {
            nextIndex = currentIndex - 1;
        }
        if (this.menuItems[nextIndex]) {
            _currentItem = this.menuItems[currentIndex];
            _nextItem = this.menuItems[nextIndex];
        }
        if (_currentItem && _nextItem) {
            this._resetSelected();
            if (_currentItem.status != 'completed' && nextAction === 'next') {
                _currentItem.status = 'completed';
                _nextItem.status = 'in_progress';
            }
            _nextItem.selected = true;
            var totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _nextItem,
                totalProgress: totalProgress
            });
        }
    };
    SidebarNavService.prototype.goToPrev = function (currentId) {
        this.goTo(currentId, 'prev');
    };
    SidebarNavService.prototype.goToNext = function (currentId) {
        this.goTo(currentId, 'next');
    };
    SidebarNavService.prototype.goToFinish = function (currentId) {
        var currentIndex = this.menuItems.findIndex(function (item) { return item.id == currentId; });
        var _currentItem = this.menuItems[currentIndex];
        if (_currentItem) {
            _currentItem.status = 'completed';
            var totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _currentItem,
                totalProgress: totalProgress
            });
        }
    };
    SidebarNavService.prototype._calculateProgress = function () {
        var totalCount = this.menuItems.length, completedCount = 0;
        this.menuItems.forEach(function (item) {
            if (item.status === 'completed') {
                completedCount += 1;
            }
        });
        var totalProgress = (completedCount / totalCount) * 100;
        return Math.round(totalProgress);
    };
    SidebarNavService.prototype._resetSelected = function () {
        this.menuItems.forEach(function (item) {
            item.selected = undefined;
        });
    };
    SidebarNavService.prototype._findLastIndex = function (searchKey, searchValue) {
        var index = this.menuItems.slice().reverse().findIndex(function (x) { return x[searchKey] === searchValue; });
        var count = this.menuItems.length - 1;
        // console.log(finalIndex)
        return index >= 0 ? count - index : index;
    };
    SidebarNavService.CONSTANTS = {
        'onCurrentActiveItem': 'EVENT.NAV.CURRENT.ACTIVE',
    };
    SidebarNavService.ngInjectableDef = i0.defineInjectable({ factory: function SidebarNavService_Factory() { return new SidebarNavService(); }, token: SidebarNavService, providedIn: "root" });
    return SidebarNavService;
}());
export { SidebarNavService };
